<button
  type="button"
  (click)="openInNewTab.emit()"
  (keydown.enter)="openInNewTab.emit()"
  class="dropdown-item">
  Open in new tab
</button>
<!-- <button type="button" (click)="disableMenu()" (keydown.enter)="disableMenu()" class="dropdown-item">Disable this menu</button> -->
